import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "react-medium-image-zoom/dist/styles.css";

function MyOrderds() {
  const navigate = useNavigate();
  const dealer_price_set = localStorage.getItem("dealer_price_set_new");
  const [rotation, setRotation] = useState(0);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  let server_url = localStorage.getItem("server_url");
  let dealer_id = localStorage.getItem("dealer_id");
  const [orderds, setOrderds] = useState([]);
  const [showButton, setShowButton] = useState([]);
  const [orderdsproduct, setOrderdsProduct] = useState([]);
  let { oid } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [driverDetails, setDriverDetails] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Debounce function
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  // Define debouncedAddToCart using useCallback at the top level
  const debouncedAddToCart = useCallback(
    debounce(async (productId, qty) => {
      if (qty < 1) {
        return; // Prevent quantity from going below 1
      }
      if (!dealer_id) {
        navigate("/Logout");
        return;
      }
      if (!productId) {
        toast("Please select product");
        return;
      }
      try {
        const formData = new FormData();
        formData.append("company_id", "2");
        formData.append("dealer_id", dealer_id);
        formData.append("order_id", oid);
        formData.append("product_id", productId);
        formData.append("qty", qty);
        const response = await axios.post(
          `${server_url}update_order.php`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        if (response.data.status === "1") {
          const updatedData = orderdsproduct.map((item) =>
            item.product_id === productId
              ? { ...item, order_details_qty: qty }
              : item,
          );
          setOrderdsProduct(updatedData);
        } else {
          toast.warning(response.data.error);
        }
        get_orderds();
      } catch (error) {
        toast("Please Try After Some Time.");
      }
    }, 300),
    [dealer_id, server_url, orderdsproduct, navigate],
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    get_orderds();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderds && orderds.length > 0) {
      const data = orderds[0];
      setDriverDetails({
        order_loading_point: data.order_loading_point || "",
        order_factory_person_name: data.order_factory_person_name || "",
        order_driver_mobile: data.order_driver_mobile || "",
        order_truck_number: data.order_truck_number || "",
        order_transport_remark: data.order_transport_remark || "",
        dealer_id: dealer_id,
        company_id: "2",
        order_id: oid,
      });
    }
  }, [dealer_id, oid, orderds]);

  const get_orderds = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("order_id", oid);
      if (!dealer_id) {
        navigate("/Logout");
      }
      if (!oid) {
        return toast("Please try after some time");
      }
      const res = await axios.post(`${server_url}order_details.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(res.data);

      if (res.data.status === "1") {
        setOrderdsProduct(res.data.result);
        setOrderds(res.data.general_info);
        setShowButton(res.data.general_info[0].order_truck_number);
      } else {
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  const cancel_orderd = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("order_id", oid);
      if (!dealer_id) {
        navigate("/Logout");
      }
      if (!oid) {
        return toast("Please try after some time");
      }
      const res = await axios.post(`${server_url}cancel_orderd.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      get_orderds();
      if (res.data.status === "1") {
        toast.success("Order cancelled successfully.");
      } else {
        toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  const handleCancelClick = () => {
    setShowCancelConfirm(true);
  };

  const handleConfirmCancel = async () => {
    setShowCancelConfirm(false);
    await cancel_orderd();
  };

  const handleCancelDismiss = () => {
    setShowCancelConfirm(false);
  };

  const isDriverDetailsChanged = () => {
    if (!orderds || orderds.length === 0 || !driverDetails) return false;
    const currentOrder = orderds[0];
    return (
      driverDetails.order_loading_point !== currentOrder.order_loading_point ||
      driverDetails.order_factory_person_name !==
        currentOrder.order_factory_person_name ||
      driverDetails.order_driver_mobile !== currentOrder.order_driver_mobile ||
      driverDetails.order_truck_number !== currentOrder.order_truck_number ||
      driverDetails.order_transport_remark !==
        currentOrder.order_transport_remark
    );
  };

  if (!driverDetails) {
    return <div>Loading...</div>;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDriverDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isDriverDetailsChanged()) {
      toast.info("No changes detected.");
      return;
    }

    try {
      const formData = new FormData();
      for (let key in driverDetails) {
        formData.append(key, driverDetails[key]);
      }

      const res = await axios.post(
        `${server_url}order_driver_detail.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res.data.status === "1") {
        toast.success(res.data.error);
        get_orderds();
      } else {
        toast.warning(res.data.error || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Failed to update vehicle details. Try again.");
    }
  };

  // Function to handle file download
  const handleFileDownload = async (fileUrl, fileName) => {
    if (!fileUrl) {
      toast.warning("File not available for download");
      return;
    }

    // Ensure absolute URL if relative (prepend server_url)
    let fullUrl = fileUrl;
    if (!fileUrl.startsWith("http") && server_url) {
      fullUrl = `${server_url.replace(/\/$/, "")}/${
        fileUrl.startsWith("/") ? fileUrl.slice(1) : fileUrl
      }`;
    }

    console.log("Attempting to download:", fullUrl);

    let loadingToast = null;

    try {
      window.open(fullUrl, "_blank");
    } catch (error) {
      console.error("Download error:", error);

      if (loadingToast) {
        toast.dismiss(loadingToast);
      }

      if (error.code === "ERR_NETWORK" || error.message.includes("timeout")) {
        toast.error("Download timed out—check your connection");
      } else if (error.response?.status === 404) {
        toast.error("File not found on server");
      } else if (error.message.includes("CORS")) {
        toast.error("Download blocked by browser security—contact support");
      } else {
        toast.error("Failed to download file");
      }
    }
  };

  const currentOrder = orderds.length > 0 ? orderds[0] : null;

  return (
    <>
      <div className="page-content">
        <Header />

        {/* Main Grid Layout for Web */}
        <div
          className={`content mt-2 ${isMobile ? "" : "web-grid-layout"}`}
          style={{
            marginTop: isMobile ? "73px" : "5000px",
            background: "#ffffff",
          }}
        >
          {/* Left Side - Order Details for Web */}
          {!isMobile && (
            <div className="order-details-left">
              {/* Vehicle Details Form */}
              {currentOrder &&
                currentOrder.order_status === "Ready For Dispatched" && (
                  <div
                    className="page-content"
                    style={{ paddingBottom: "0px" }}
                  >
                    <div
                      className="card card-style web-card"
                      style={{
                        color: "#000000",
                        background: "#ffffff",
                        border: "1px solid #e5e5e5",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                      }}
                    >
                      <div className="content">
                        <h3 style={{ color: "#000000", marginBottom: "20px" }}>
                          Vehicle Details
                        </h3>

                        <form
                          onSubmit={handleSubmit}
                          style={{ marginTop: "15px" }}
                        >
                          {driverDetails && (
                            <div className="web-form-grid">
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_loading_point"
                                  className="form-control"
                                  placeholder="Loading point"
                                  value={driverDetails.order_loading_point}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Loading point
                                </label>
                              </div>

                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_factory_person_name"
                                  className="form-control"
                                  placeholder="Factory person name"
                                  value={
                                    driverDetails.order_factory_person_name
                                  }
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Factory person name
                                </label>
                              </div>

                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="number"
                                  name="order_driver_mobile"
                                  className="form-control"
                                  placeholder="Driver Mobile"
                                  value={driverDetails.order_driver_mobile}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Driver Mobile
                                </label>
                              </div>
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_truck_number"
                                  className="form-control"
                                  placeholder="Truck Number"
                                  value={driverDetails.order_truck_number}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Truck Number
                                </label>
                              </div>
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_transport_remark"
                                  className="form-control"
                                  placeholder="Transport Remark"
                                  value={driverDetails.order_transport_remark}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Transport Remark
                                </label>
                              </div>
                            </div>
                          )}
                          {currentOrder.order_status ===
                            "Ready For Dispatched" &&
                            (showButton && showButton.length > 0 ? (
                              <button
                                style={{
                                  width: "100%",
                                  backgroundColor: "#000000",
                                  color: "white",
                                  marginTop: "20px",
                                  border: "1px solid #000000",
                                }}
                                type="submit"
                                disabled={!isDriverDetailsChanged()}
                                className="btn btn-3d btn-m btn-full rounded-xl text-uppercase font-900 shadow-s"
                              >
                                Submitted Details
                              </button>
                            ) : (
                              <button
                                style={{
                                  width: "100%",
                                  background: "#000000",
                                  borderColor: "#000000",
                                  color: "#fff",
                                  marginTop: "20px",
                                }}
                                type="submit"
                                disabled={!isDriverDetailsChanged()}
                                className="btn btn-3d btn-m btn-full rounded-xl text-uppercase font-900 shadow-s "
                              >
                                Update Vehicle Details
                              </button>
                            ))}
                        </form>
                      </div>
                    </div>
                    <br />
                  </div>
                )}

              {/* Driver Details Display */}
              {currentOrder &&
                currentOrder.order_status === "Order Dispatched" && (
                  <div
                    style={{
                      marginTop: "10px",
                      color: "#000000",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                    className="card card-style web-card mx-0 mb-3"
                  >
                    <div
                      className="content mb-0"
                      style={{ paddingBottom: "20px" }}
                    >
                      <div className="align-self-center">
                        <h3 style={{ color: "#000000", marginBottom: "20px" }}>
                          Driver Details
                        </h3>
                        <div className="web-details-grid">
                          <div className="detail-item">
                            <span
                              style={{ color: "#000000", fontWeight: "bold" }}
                            >
                              Loading Point:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_loading_point}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span
                              style={{ color: "#000000", fontWeight: "bold" }}
                            >
                              Factory Person Name:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_factory_person_name}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span
                              style={{ color: "#000000", fontWeight: "bold" }}
                            >
                              Driver Mobile:
                            </span>
                            <span
                              style={{ color: "#000000" }}
                              className="mb-n1 font-18 color-green-dark"
                            >
                              {currentOrder.order_driver_mobile}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span
                              style={{ color: "#000000", fontWeight: "bold" }}
                            >
                              Truck Number:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_truck_number}
                            </span>
                          </div>
                          <div className="detail-item">
                            <span
                              style={{ color: "#000000", fontWeight: "bold" }}
                            >
                              Transport Remark:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_transport_remark}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {/* Order Summary for Web */}
              {currentOrder && (
                <div
                  className="card card-style web-card mx-0 mb-3"
                  style={{
                    color: "#000000",
                    background: "#ffffff",
                    border: "1px solid #e5e5e5",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    className="content mb-0"
                    style={{ paddingBottom: "20px" }}
                  >
                    <div className="order-header-web">
                      <div>
                        <h1
                          className="mb-n2 font-16"
                          style={{ color: "#000000" }}
                        >
                          Order #{oid}
                        </h1>
                        <p style={{ color: "#666666", opacity: "0.8" }}>
                          {currentOrder.order_date}
                        </p>
                      </div>
                      <h3
                        style={{
                          color:
                            currentOrder.order_status === "Order Pending"
                              ? "#c9bc00"
                              : currentOrder.order_status === "Order Approved"
                                ? "#28a745"
                                : currentOrder.order_status ===
                                    "Order Dispatched"
                                  ? "#007bff"
                                  : currentOrder.order_status ===
                                      "Order On Hold"
                                    ? "#FFA500"
                                    : currentOrder.order_status ===
                                        "Order Rejected"
                                      ? "#dc3545"
                                      : currentOrder.order_status ===
                                          "Order Cancelled"
                                        ? "#000000"
                                        : currentOrder.order_status ===
                                            "In Production"
                                          ? "#17a2b8"
                                          : currentOrder.order_status ===
                                              "Ready For Dispatched"
                                            ? "#6f42c1"
                                            : "#000000",
                        }}
                      >
                        {currentOrder.order_status}
                      </h3>
                    </div>

                    <div className="web-order-summary">
                      {dealer_price_set === "1" && (
                        <>
                          <div className="summary-row">
                            <span style={{ color: "#000000" }}>Sub Total:</span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_final_total}
                            </span>
                          </div>

                          {currentOrder.order_igst > 0 ? (
                            <div className="summary-row">
                              <span style={{ color: "#000000" }}>IGST:</span>
                              <span style={{ color: "#000000" }}>
                                {currentOrder.order_igst}
                              </span>
                            </div>
                          ) : (
                            <>
                              <div className="summary-row">
                                <span style={{ color: "#000000" }}>CGST:</span>
                                <span style={{ color: "#000000" }}>
                                  {currentOrder.order_cgst}
                                </span>
                              </div>
                              <div className="summary-row">
                                <span style={{ color: "#000000" }}>SGST:</span>
                                <span style={{ color: "#000000" }}>
                                  {currentOrder.order_sgst}
                                </span>
                              </div>
                            </>
                          )}

                          <div className="summary-row">
                            <span style={{ color: "#000000" }}>
                              Freight Charge With GST:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_freight_charge_with_gst}
                            </span>
                          </div>

                          <div
                            className="summary-row total"
                            style={{ borderColor: "#e5e5e5" }}
                          >
                            <span style={{ color: "#000000" }}>
                              Final Total:
                            </span>
                            <span
                              className="color-green-dark"
                              style={{ color: "#10b981" }}
                            >
                              {currentOrder.order_final_total_with_gst}
                            </span>
                          </div>

                          <div className="summary-row">
                            <span style={{ color: "#000000" }}>
                              Paid Amount:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_total_paid}
                            </span>
                          </div>

                          <div className="summary-row">
                            <span style={{ color: "#000000" }}>
                              Remaining Amount:
                            </span>
                            <span style={{ color: "#000000" }}>
                              {currentOrder.order_remaining_amount}
                            </span>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="order-dates">
                      {currentOrder.order_status === "Order Dispatched" && (
                        <div className="date-item">
                          <span style={{ color: "#000000" }}>Due Date:</span>
                          <span style={{ color: "#000000" }}>
                            {currentOrder.order_due_date}
                          </span>
                        </div>
                      )}
                      {currentOrder.overdue_in_days && (
                        <div className="date-item overdue">
                          <span style={{ color: "#dc3545" }}>Overdue:</span>
                          <span style={{ color: "#dc3545" }}>
                            {currentOrder.overdue_in_days} days
                          </span>
                        </div>
                      )}
                    </div>

                    {currentOrder.order_admin_remark && (
                      <div className="order-remark">
                        <p
                          style={{
                            color: "#000000",
                            marginTop: "15px",
                            fontStyle: "italic",
                          }}
                        >
                          {currentOrder.order_admin_remark}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Order Stats for Web */}
              {currentOrder && (
                <>
                  <div
                    className="card card-style web-card mx-0 mb-3"
                    style={{
                      color: "#000000",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        padding: "20px",
                        display: "flex",
                        backgroundColor: "#6f42c1",
                        borderRadius: "12px",
                        color: "white",
                      }}
                      className="order-stats"
                    >
                      <div className="stat-item">
                        <div className="stat-label">
                          <b>Total Weight</b>
                        </div>
                        <div className="stat-value">
                          {currentOrder.total_weight_kg}
                          {currentOrder.total_weight_ton}
                        </div>
                      </div>
                      <div className="stat-item">
                        <div className="stat-label">
                          <b>Total Boxes</b>
                        </div>
                        <div className="stat-value">
                          {currentOrder.total_box}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Loading Images Section */}
                  {currentOrder &&
                    (currentOrder.order_loading_photo1 ||
                      currentOrder.order_loading_photo2) && (
                      <div
                        className="card card-style web-card mx-0"
                        style={{
                          color: "#000000",
                          background: "#ffffff",
                          border: "1px solid #e5e5e5",
                          boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                        }}
                      >
                        <div className="content">
                          <h3
                            style={{ color: "#000000", marginBottom: "20px" }}
                          >
                            Loading Images
                          </h3>
                          <div className="loading-images-grid">
                            {currentOrder.order_loading_photo1 && (
                              <div className="loading-image-container">
                                <img
                                  src={currentOrder.order_loading_photo1}
                                  alt="Loading Image 1"
                                  className="loading-image"
                                  onClick={() =>
                                    setSelectedImage(
                                      currentOrder.order_loading_photo1,
                                    )
                                  }
                                />
                              </div>
                            )}
                            {currentOrder.order_loading_photo2 && (
                              <div className="loading-image-container">
                                <img
                                  src={currentOrder.order_loading_photo2}
                                  alt="Loading Image 2"
                                  className="loading-image"
                                  onClick={() =>
                                    setSelectedImage(
                                      currentOrder.order_loading_photo2,
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Invoice and Packing List Buttons for Web */}
                  <div className="content">
                    <div className="download-buttons-grid">
                      {currentOrder && currentOrder.order_invoice_file && (
                        <button
                          style={{
                            width: "100%",
                            padding: "15px",
                            backgroundColor: "#000000",
                            color: "white",
                            borderRadius: "8px",
                            border: "1px solid #000000",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                          }}
                          className="download-btn"
                          onClick={() =>
                            handleFileDownload(
                              currentOrder.order_invoice_file,
                              `invoice_${oid}.pdf`,
                            )
                          }
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#db4437";
                            e.target.style.borderColor = "#db4437";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#000000";
                            e.target.style.borderColor = "#000000";
                          }}
                        >
                          <i
                            className="white fa fa-download"
                            aria-hidden="true"
                          ></i>{" "}
                          Invoice
                        </button>
                      )}
                      {currentOrder && currentOrder.order_packing_list_file && (
                        <button
                          style={{
                            width: "100%",
                            padding: "15px",
                            backgroundColor: "#000000",
                            color: "white",
                            borderRadius: "8px",
                            border: "1px solid #000000",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                          }}
                          className="download-btn"
                          onClick={() =>
                            handleFileDownload(
                              currentOrder.order_packing_list_file,
                              `packing_list_${oid}.pdf`,
                            )
                          }
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#db4437";
                            e.target.style.borderColor = "#db4437";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#000000";
                            e.target.style.borderColor = "#000000";
                          }}
                        >
                          <i
                            className="white fa fa-download"
                            aria-hidden="true"
                          ></i>{" "}
                          Packing List
                        </button>
                      )}
                    </div>
                  </div>
                </>
              )}

              {/* Cancel Order Button for Web */}
              {currentOrder &&
                currentOrder.order_status === "Order Pending" && (
                  <div className="cancel-order-section">
                    <button
                      style={{
                        width: "100%",
                        color: "#ffffff",
                        background: "#000000",
                        borderColor: "#000000",
                        transition: "all 0.3s ease",
                      }}
                      type="button"
                      onClick={handleCancelClick}
                      className="btn btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s"
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#db4437";
                        e.target.style.borderColor = "#db4437";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#000000";
                        e.target.style.borderColor = "#000000";
                      }}
                    >
                      Cancel Order
                    </button>
                  </div>
                )}
            </div>
          )}

          {/* Right Side - Product List for Web */}
          {!isMobile && (
            <div className="order-products-right">
              <div className="products-header">
                <h3 style={{ color: "#000000", marginBottom: "20px" }}>
                  Order Items ({orderdsproduct.length})
                </h3>
              </div>

              <div className="products-grid">
                {orderdsproduct.map((orderdsproduct) => (
                  <div
                    className="product-card web-product-card"
                    style={{
                      color: "#000000",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                    key={orderdsproduct.order_details_product_id}
                  >
                    <div className="product-content">
                      <div className="product-image-section">
                        <Link
                          to={`/ProductDetails/${
                            orderdsproduct.product_id
                          }/${orderdsproduct.product_design_name
                            .trim()
                            .split(/\s+/)
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase(),
                            )
                            .join("")}`}
                        >
                          <img
                            src={orderdsproduct.product_image}
                            className="product-image"
                            alt={orderdsproduct.product_design_name}
                            onClick={() =>
                              setSelectedImage(orderdsproduct.product_image)
                            }
                          />
                        </Link>
                      </div>

                      <div className="product-details">
                        <h4 className="product-title">
                          {orderdsproduct.product_design_name}
                        </h4>

                        <div className="product-info">
                          <div className="info-item">
                            <span
                              className="info-label"
                              style={{ color: "#666666" }}
                            >
                              Code:
                            </span>
                            <span
                              className="info-value"
                              style={{ color: "#000000" }}
                            >
                              {orderdsproduct.product_name}
                            </span>
                          </div>
                          <div className="info-item">
                            <span
                              className="info-label"
                              style={{ color: "#666666" }}
                            >
                              Size:
                            </span>
                            <span
                              className="info-value"
                              style={{ color: "#000000" }}
                            >
                              {orderdsproduct.size_name}
                            </span>
                          </div>
                          <div className="info-item">
                            <span
                              className="info-label"
                              style={{ color: "#666666" }}
                            >
                              Series:
                            </span>
                            <span
                              className="info-value"
                              style={{ color: "#000000" }}
                            >
                              {orderdsproduct.series_name}
                            </span>
                          </div>
                          <div className="info-item">
                            <span
                              className="info-label"
                              style={{ color: "#666666" }}
                            >
                              Box Details:
                            </span>
                            <span
                              className="info-value"
                              style={{ color: "#000000" }}
                            >
                              {orderdsproduct.product_total_box}
                            </span>
                          </div>
                        </div>

                        {dealer_price_set === "1" && (
                          <div className="product-pricing">
                            {orderdsproduct.order_details_mrp !==
                              orderdsproduct.order_details_dealer_price && (
                              <span
                                className="original-price"
                                style={{ color: "#999999" }}
                              >
                                {orderdsproduct.order_details_mrp}
                              </span>
                            )}
                            <span
                              className="current-price"
                              style={{ color: "#10b981" }}
                            >
                              {orderdsproduct.order_details_dealer_price}
                            </span>
                          </div>
                        )}

                        <div className="product-quantity-section">
                          {currentOrder &&
                          currentOrder.order_status === "Order Pending" ? (
                            <div className="quantity-stepper">
                              {orderdsproduct.order_details_qty > 1 && (
                                <button
                                  className="stepper-btn"
                                  onClick={() =>
                                    debouncedAddToCart(
                                      orderdsproduct.order_details_product_id,
                                      orderdsproduct.order_details_qty - 1,
                                    )
                                  }
                                  style={{
                                    background: "transparent",
                                    color: "#ffffff",
                                  }}
                                >
                                  <i className="white fa fa-minus"></i>
                                </button>
                              )}
                              <input
                                type="number"
                                min="1"
                                max="99"
                                value={orderdsproduct.order_details_qty}
                                readOnly
                                className="quantity-input"
                                style={{
                                  color: "#000000",
                                  background: "#ffffff",
                                  borderColor: "#e5e5e5",
                                }}
                              />
                              <button
                                className="stepper-btn"
                                onClick={() =>
                                  debouncedAddToCart(
                                    orderdsproduct.order_details_product_id,
                                    +orderdsproduct.order_details_qty + 1,
                                  )
                                }
                                style={{
                                  background: "transparent",
                                  color: "#ffffff",
                                }}
                              >
                                <i className="white fa fa-plus"></i>
                              </button>
                            </div>
                          ) : (
                            <div className="quantity-display">
                              <span
                                className="quantity-label"
                                style={{ color: "#666666" }}
                              >
                                Quantity:
                              </span>
                              <span
                                className="quantity-value"
                                style={{ color: "#000000" }}
                              >
                                {orderdsproduct.order_details_qty}
                              </span>
                            </div>
                          )}

                          {dealer_price_set === "1" && (
                            <div
                              className="total-price"
                              style={{ color: "#10b981" }}
                            >
                              Total: {orderdsproduct.order_details_total_price}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Mobile Layout - Original Design */}
          {isMobile &&
            orderds.map((orderds) => (
              <React.Fragment key={orderds.order_final_total}>
                {orderds.order_status === "Ready For Dispatched" && (
                  <div
                    className="page-content"
                    style={{ paddingBottom: "0px" }}
                  >
                    <div
                      className="card card-style"
                      style={{
                        color: "#000000",
                        background: "#ffffff",
                        border: "1px solid #e5e5e5",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                      }}
                    >
                      <div className="content">
                        <h3 style={{ color: "#000000" }}>Vehicle Details</h3>

                        <form
                          onSubmit={handleSubmit}
                          style={{ marginTop: "15px" }}
                        >
                          {driverDetails && (
                            <>
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_loading_point"
                                  className="form-control"
                                  placeholder="Loading point"
                                  value={driverDetails.order_loading_point}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Loading point
                                </label>
                              </div>

                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_factory_person_name"
                                  className="form-control"
                                  placeholder="Factory person name"
                                  value={
                                    driverDetails.order_factory_person_name
                                  }
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Factory person name
                                </label>
                              </div>

                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="number"
                                  name="order_driver_mobile"
                                  className="form-control"
                                  placeholder="Driver Mobile"
                                  value={driverDetails.order_driver_mobile}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Driver Mobile
                                </label>
                              </div>
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_truck_number"
                                  className="form-control"
                                  placeholder="Truck Number"
                                  value={driverDetails.order_truck_number}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Truck Number
                                </label>
                              </div>
                              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                                <input
                                  type="text"
                                  name="order_transport_remark"
                                  className="form-control"
                                  placeholder="Transport Remark"
                                  value={driverDetails.order_transport_remark}
                                  onChange={handleChange}
                                  required
                                  style={{
                                    color: "#000000",
                                    background: "#ffffff",
                                    border: "1px solid #e5e5e5",
                                  }}
                                />
                                <label
                                  className="color-highlight"
                                  style={{
                                    color: "#666666",
                                    background: "#ffffff",
                                  }}
                                >
                                  Transport Remark
                                </label>
                              </div>
                            </>
                          )}
                          {orderds.order_status === "Ready For Dispatched" &&
                            (showButton && showButton.length > 0 ? (
                              <button
                                style={{
                                  width: "100%",
                                  backgroundColor: "#000000",
                                  color: "white",
                                  border: "1px solid #000000",
                                }}
                                type="submit"
                                disabled={!isDriverDetailsChanged()}
                                className="btn btn-3d btn-m btn-full rounded-xl text-uppercase font-900 shadow-s"
                              >
                                Submitted Details
                              </button>
                            ) : (
                              <button
                                style={{
                                  width: "100%",
                                  background: "#000000",
                                  borderColor: "#000000",
                                  color: "#fff",
                                }}
                                type="submit"
                                disabled={!isDriverDetailsChanged()}
                                className="btn btn-3d btn-m btn-full rounded-xl text-uppercase font-900 shadow-s "
                              >
                                Update Vehicle Details
                              </button>
                            ))}
                        </form>
                      </div>
                    </div>
                    <br />
                  </div>
                )}

                {orderds.order_status === "Order Dispatched" && (
                  <div
                    style={{
                      marginTop: "10px",
                      color: "#000000",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                    className="card card-style mx-0 mb-3"
                    key={orderds.order_final_total}
                  >
                    <div
                      className="content mb-0"
                      style={{ paddingBottom: "20px" }}
                    >
                      <div className="align-self-center">
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "50%", color: "#000000" }}>
                                <b>Loading Point:</b>
                              </td>
                              <td style={{ float: "right", color: "#000000" }}>
                                {orderds.order_loading_point}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", color: "#000000" }}>
                                <b>Factory Person Name:</b>
                              </td>
                              <td style={{ float: "right", color: "#000000" }}>
                                {orderds.order_factory_person_name}
                              </td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", color: "#000000" }}>
                                <b>Driver Mobile:</b>
                              </td>
                              <td>
                                <h2
                                  style={{ float: "right", color: "#000000" }}
                                  className="mb-n1 font-18 color-green-dark"
                                >
                                  {orderds.order_driver_mobile}
                                </h2>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", color: "#000000" }}>
                                <b>Truck Number:</b>
                              </td>
                              <td style={{ float: "right", color: "#000000" }}>
                                {orderds.order_truck_number}
                              </td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", color: "#000000" }}>
                                <b>Transport Remark:</b>
                              </td>
                              <td style={{ float: "right", color: "#000000" }}>
                                {orderds.order_transport_remark}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className="card card-style mx-0 mb-3"
                  style={{
                    color: "#000000",
                    background: "#ffffff",
                    border: "1px solid #e5e5e5",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    className="content mb-0"
                    style={{ paddingBottom: "20px" }}
                  >
                    <div className="align-self-center">
                      <h3
                        style={{
                          float: "right",
                          paddingBottom: "0px",
                          color:
                            orderds.order_status === "Order Pending"
                              ? "#c9bc00"
                              : orderds.order_status === "Order Approved"
                                ? "#28a745"
                                : orderds.order_status === "Order Dispatched"
                                  ? "#007bff"
                                  : orderds.order_status === "Order On Hold"
                                    ? "#FFA500"
                                    : orderds.order_status === "Order Rejected"
                                      ? "#dc3545"
                                      : orderds.order_status ===
                                          "Order Cancelled"
                                        ? "#000000"
                                        : orderds.order_status ===
                                            "In Production"
                                          ? "#17a2b8"
                                          : orderds.order_status ===
                                              "Ready For Dispatched"
                                            ? "#6f42c1"
                                            : "#000000",
                        }}
                      >
                        {orderds.order_status}
                      </h3>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "70%" }}>
                              <b>
                                <h1
                                  className="mb-n2 font-16"
                                  style={{ color: "#000000" }}
                                >
                                  #{oid}
                                </h1>
                              </b>
                            </td>
                            <td style={{ float: "right" }}>
                              <h1
                                className="mb-n2 font-16"
                                style={{ color: "#000000" }}
                              >
                                {orderds.order_date}
                              </h1>
                            </td>
                          </tr>
                          <tr
                            style={
                              dealer_price_set !== "1"
                                ? { display: "none" }
                                : {}
                            }
                          >
                            <td style={{ width: "70%", color: "#000000" }}>
                              <b>Sub Total:</b>
                            </td>
                            <td style={{ float: "right", color: "#000000" }}>
                              {orderds.order_final_total}
                            </td>
                          </tr>
                          {orderds.order_igst > 0 ? (
                            <>
                              <tr
                                style={
                                  dealer_price_set !== "1"
                                    ? { display: "none" }
                                    : {}
                                }
                              >
                                <td style={{ width: "70%", color: "#000000" }}>
                                  <b>IGST:</b>
                                </td>
                                <td
                                  style={{ float: "right", color: "#000000" }}
                                >
                                  {orderds.order_igst}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              <tr
                                style={
                                  dealer_price_set !== "1"
                                    ? { display: "none" }
                                    : {}
                                }
                              >
                                <td style={{ width: "70%", color: "#000000" }}>
                                  <b>CGST:</b>
                                </td>
                                <td
                                  style={{ float: "right", color: "#000000" }}
                                >
                                  {orderds.order_cgst}
                                </td>
                              </tr>
                              <tr
                                style={
                                  dealer_price_set !== "1"
                                    ? { display: "none" }
                                    : {}
                                }
                              >
                                <td style={{ width: "70%", color: "#000000" }}>
                                  <b>SGST:</b>
                                </td>
                                <td
                                  style={{ float: "right", color: "#000000" }}
                                >
                                  {orderds.order_sgst}
                                </td>
                              </tr>
                            </>
                          )}

                          <tr
                            style={
                              dealer_price_set !== "1"
                                ? { display: "none" }
                                : {}
                            }
                          >
                            <td style={{ width: "70%", color: "#000000" }}>
                              <b>Freight Charge With GST:</b>
                            </td>
                            <td style={{ float: "right", color: "#000000" }}>
                              {orderds.order_freight_charge_with_gst}
                            </td>
                          </tr>

                          <tr
                            style={
                              dealer_price_set !== "1"
                                ? { display: "none" }
                                : { borderTop: "0.5px solid #e5e5e5" }
                            }
                          >
                            <td style={{ width: "70%", color: "#000000" }}>
                              <b>Final Total:</b>
                            </td>
                            <td>
                              <h2
                                style={{ float: "right", color: "#10b981" }}
                                className="mb-n1 font-18 color-green-dark"
                              >
                                {orderds.order_final_total_with_gst}
                              </h2>
                            </td>
                          </tr>
                          <tr
                            style={
                              dealer_price_set !== "1"
                                ? { display: "none" }
                                : { borderTop: "0.5px solid #e5e5e5" }
                            }
                          >
                            <td style={{ width: "70%", color: "#000000" }}>
                              <b>Paid Amount:</b>
                            </td>
                            <td style={{ float: "right", color: "#000000" }}>
                              {orderds.order_total_paid}
                            </td>
                          </tr>

                          <tr
                            style={
                              dealer_price_set !== "1"
                                ? { display: "none" }
                                : {}
                            }
                          >
                            <td style={{ width: "70%", color: "#000000" }}>
                              <b>Remaining Amount:</b>
                            </td>
                            <td style={{ float: "right", color: "#000000" }}>
                              {orderds.order_remaining_amount}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="font-18 mb-0"
                        style={{
                          width: "100%",
                          color: "#dc3545",
                          textAlign: "left",
                        }}
                      >
                        {orderds.order_status === "Order Dispatched" && (
                          <>Due Date:{orderds.order_due_date}</>
                        )}
                        <span
                          className="font-18 mb-0"
                          style={{
                            float: "Right",
                            color: "#dc3545",
                            textAlign: "right",
                          }}
                        >
                          {orderds.overdue_in_days &&
                            "Overdue: " + orderds.overdue_in_days}
                        </span>
                      </p>
                    </div>
                    {orderds.order_description && orderds.order_description}

                    {orderds.order_status === "Order Pending" ? (
                      ""
                    ) : (
                      <>
                        {orderds.order_description ? (
                          <>
                            <br />
                            <p
                              style={{
                                lineHeight: "1.5",
                                margin: "0px",
                                color: "#000000",
                              }}
                            >
                              {orderds.order_admin_remark}
                            </p>
                          </>
                        ) : (
                          <p
                            style={{
                              lineHeight: "1.5",
                              margin: "0px",
                              color: "#000000",
                            }}
                          >
                            {orderds.order_admin_remark}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div
                  className="card card-style mx-0 mb-3"
                  key={orderds.order_final_total}
                >
                  <div
                    style={{
                      paddingBottom: "20px",
                      display: "flex",
                      backgroundColor: "#6f42c1",
                      borderRadius: "12px",
                    }}
                    data-menu="menu-reservation"
                    className="btn rounded-m text-uppercase font-700"
                  >
                    <p
                      style={{
                        color: "white",
                        paddingTop: "7px",
                        marginBottom: "-10px",
                        textAlign: "left",
                        width: "100%",
                        marginLeft: "5px",
                      }}
                    >
                      {orderds.total_weight_kg}
                      {orderds.total_weight_ton}
                    </p>
                    <p
                      style={{
                        color: "white",
                        paddingTop: "7px",
                        marginBottom: "-10px",
                        textAlign: "right",
                        width: "100%",
                        marginRight: "5px",
                      }}
                    >
                      {orderds.total_box}
                    </p>
                  </div>
                </div>

                {/* Loading Images Section for Mobile */}
                {(orderds.order_loading_photo1 ||
                  orderds.order_loading_photo2) && (
                  <div
                    className="card card-style mx-0 mb-3"
                    style={{
                      color: "#000000",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="content">
                      <h3 style={{ color: "#000000", marginBottom: "20px" }}>
                        Loading Images
                      </h3>
                      <div className="loading-images-grid-mobile">
                        {orderds.order_loading_photo1 && (
                          <div className="loading-image-container-mobile">
                            <img
                              src={orderds.order_loading_photo1}
                              alt="Loading Image 1"
                              className="loading-image-mobile"
                              onClick={() =>
                                setSelectedImage(orderds.order_loading_photo1)
                              }
                            />
                          </div>
                        )}
                        {orderds.order_loading_photo2 && (
                          <div className="loading-image-container-mobile">
                            <img
                              src={orderds.order_loading_photo2}
                              alt="Loading Image 2"
                              className="loading-image-mobile"
                              onClick={() =>
                                setSelectedImage(orderds.order_loading_photo2)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Invoice and Packing List Buttons for Mobile */}
                <div className="content">
                  <div className="download-buttons-mobile">
                    {orderds.order_invoice_file && (
                      <button
                        style={{
                          width: "48%",
                          padding: "5px",
                          backgroundColor: "#000000",
                          color: "white",
                          borderRadius: "12px",
                          border: "1px solid #000000",
                          fontWeight: "bold",
                          cursor: "pointer",
                          float: "left",
                          transition: "all 0.3s ease",
                        }}
                        className="download-btn-mobile"
                        onClick={() =>
                          handleFileDownload(
                            orderds.order_invoice_file,
                            `invoice_${oid}.pdf`,
                          )
                        }
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#db4437";
                          e.target.style.borderColor = "#db4437";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#000000";
                          e.target.style.borderColor = "#000000";
                        }}
                      >
                        <i
                          className="white fa fa-download"
                          aria-hidden="true"
                        ></i>{" "}
                        Invoice
                      </button>
                    )}
                    {orderds.order_packing_list_file && (
                      <button
                        style={{
                          width: "48%",
                          padding: "5px",
                          backgroundColor: "#000000",
                          color: "white",
                          borderRadius: "12px",
                          border: "1px solid #000000",
                          fontWeight: "bold",
                          cursor: "pointer",
                          float: "right",
                          transition: "all 0.3s ease",
                        }}
                        className="download-btn-mobile"
                        onClick={() =>
                          handleFileDownload(
                            orderds.order_packing_list_file,
                            `packing_list_${oid}.pdf`,
                          )
                        }
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#db4437";
                          e.target.style.borderColor = "#db4437";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#000000";
                          e.target.style.borderColor = "#000000";
                        }}
                      >
                        <i
                          className="white fa fa-download"
                          aria-hidden="true"
                        ></i>{" "}
                        Packing List
                      </button>
                    )}
                  </div>
                </div>
              </React.Fragment>
            ))}

          {/* Mobile Products */}
          {isMobile && (
            <div className="content" style={{ margin: "20px 10px 20px 10px" }}>
              {orderdsproduct.map((orderdsproduct) => (
                <div
                  className="card card-style mx-0 mb-3"
                  style={{
                    color: "#000000",
                    background: "#ffffff",
                    border: "1px solid #e5e5e5",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                  }}
                  key={orderdsproduct.order_details_product_id}
                >
                  <div className="content mb-0">
                    <div className="d-flex mb-3">
                      <Link
                        to={`/ProductDetails/${
                          orderdsproduct.product_id
                        }/${orderdsproduct.product_design_name
                          .trim()
                          .split(/\s+/)
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase(),
                          )
                          .join("")}`}
                      >
                        <img
                          src={orderdsproduct.product_image}
                          className="rounded-m me-3"
                          alt={orderdsproduct.product_design_name}
                          onClick={() =>
                            setSelectedImage(orderdsproduct.product_image)
                          }
                          style={{
                            objectFit: "cover",
                            maxHeight: "100vh",
                            width: "160px",
                          }}
                        />
                      </Link>

                      <div className="align-self-center">
                        <h4
                          className="mb-0"
                          style={{ fontSize: "15px", color: "#000000" }}
                        >
                          {orderdsproduct.product_design_name}
                        </h4>
                        <Link
                          to={`/ProductDetails/${orderdsproduct.product_id}`}
                        >
                          <p
                            style={{
                              lineHeight: "20px",
                              paddingTop: "10px",
                              marginBottom: "0px",
                              color: "#000000",
                            }}
                            className="font-14 opacity-50"
                          >
                            Code: {orderdsproduct.product_name}
                            <br />
                            Size: {orderdsproduct.size_name}
                            <br />
                            Series: {orderdsproduct.series_name}
                            <br />
                            {orderdsproduct.product_total_box}
                          </p>
                        </Link>
                        {dealer_price_set === "1" ? (
                          <h2
                            style={{ marginTop: "5px" }}
                            className="mb-n1 font-18 color-green-dark"
                          >
                            {orderdsproduct.order_details_mrp !==
                              orderdsproduct.order_details_dealer_price && (
                              <span
                                style={{
                                  fontWeight: "300",
                                  textDecoration: "line-through",
                                  color: "#999999",
                                }}
                              >
                                {orderdsproduct.order_details_mrp}
                              </span>
                            )}{" "}
                            <span style={{ color: "#10b981" }}>
                              {orderdsproduct.order_details_dealer_price}
                            </span>
                          </h2>
                        ) : (
                          ""
                        )}
                        <p
                          style={{ marginTop: "5px", color: "#000000" }}
                          className="font-15 opacity-50"
                        >
                          {orderds.length > 0 &&
                          orderds[0].order_status === "Order Pending" ? (
                            <div
                              className="stepper rounded-s pt-1"
                              style={{
                                float: "right",
                                marginRight: "50px",
                                color: "#ffffff",
                                backgroundColor: "#000000",
                                border: "1px solid #000000",
                              }}
                            >
                              {orderdsproduct.order_details_qty > 1 && (
                                <Link
                                  className="stepper-sub"
                                  onClick={() =>
                                    debouncedAddToCart(
                                      orderdsproduct.order_details_product_id,
                                      orderdsproduct.order_details_qty - 1,
                                    )
                                  }
                                >
                                  <i
                                    style={{
                                      marginTop: "10px",
                                      color: "#ffffff",
                                    }}
                                    className="white fa fa-minus color-theme opacity-40"
                                  ></i>
                                </Link>
                              )}
                              <input
                                type="number"
                                min="1"
                                max="99"
                                value={orderdsproduct.order_details_qty}
                                readOnly
                                style={{
                                  color: "#000000",
                                  background: "#ffffff",
                                }}
                              />
                              <Link
                                className="stepper-add"
                                onClick={() =>
                                  debouncedAddToCart(
                                    orderdsproduct.order_details_product_id,
                                    +orderdsproduct.order_details_qty + 1,
                                  )
                                }
                              >
                                <i
                                  style={{
                                    marginTop: "10px",
                                    color: "#ffffff",
                                  }}
                                  className="white fa fa-plus color-theme opacity-40"
                                ></i>
                              </Link>
                            </div>
                          ) : (
                            <>Qty: {orderdsproduct.order_details_qty}</>
                          )}
                          <br />
                          <br />
                          {dealer_price_set === "1" ? (
                            <>
                              Total {orderdsproduct.order_details_total_price}
                            </>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Cancel Order for Mobile */}
        {isMobile &&
          currentOrder &&
          currentOrder.order_status === "Order Pending" && (
            <center>
              <button
                style={{
                  width: "50%",
                  color: "#ffffff",
                  background: "#000000",
                  borderColor: "#000000",
                  transition: "all 0.3s ease",
                }}
                type="button"
                onClick={handleCancelClick}
                className="btn btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s "
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#db4437";
                  e.target.style.borderColor = "#db4437";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#000000";
                  e.target.style.borderColor = "#000000";
                }}
              >
                Cancel Order
              </button>
            </center>
          )}
      </div>

      {/* Modal Components */}
      {showCancelConfirm && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ background: "#ffffff" }}>
              <div className="modal-header">
                <h5 className="modal-title" style={{ color: "#000000" }}>
                  Confirm Cancel
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCancelDismiss}
                ></button>
              </div>
              <div className="modal-body" style={{ color: "#000000" }}>
                Are you sure you want to cancel this order?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancelDismiss}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmCancel}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedImage && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.95)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
            overflow: "hidden",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "100%",
              margin: 0,
            }}
          >
            <div
              className="modal-content"
              style={{
                background: "transparent",
                border: "none",
                height: "100%",
              }}
            >
              <div
                className="modal-body text-center"
                style={{ height: "100%" }}
              >
                <center style={{ paddingTop: "25%" }}>
                  <TransformWrapper
                    initialScale={1}
                    minScale={0.5}
                    maxScale={15}
                    panning={true}
                    wheel={true}
                  >
                    <TransformComponent>
                      <img
                        src={selectedImage}
                        className="img-fluid"
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "100%",
                          cursor: "grab",
                          transform: `rotate(${rotation}deg)`,
                          transition: "transform 0.3s ease",
                        }}
                        alt="Zoomed"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </center>
                <button
                  className="btn btn-secondary"
                  onClick={() => setRotation((prev) => prev - 90)}
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "35%",
                    zIndex: 1061,
                  }}
                >
                  ↺
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => setRotation((prev) => prev + 90)}
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    right: "35%",
                    zIndex: 1061,
                  }}
                >
                  ↻
                </button>

                <button
                  className="btn btn-danger mt-3"
                  onClick={() => setSelectedImage(null)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: 1060,
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />

      {/* CSS Styles */}
      <style jsx>{`
      .web-card {
      border: 1px solid rgb(229, 229, 229) !important;
      }
        .white {
           color: rgb(219, 68, 55) !important;
        }
           .redcolor{
          color: rgb(219, 68, 55) !important;
          }
        .page-content {
          background: #ffffff;
        }

        .web-grid-layout {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px;
          background: #ffffff;
        }

        .order-details-left {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .order-products-right {
          display: flex;
          flex-direction: column;
        }

        .web-card {
          border-radius: 12px;
          border: 1px solid #e5e5e5;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .web-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        .web-details-grid {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .detail-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid #e5e5e5;
        }

        .order-header-web {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 20px;
        }

        .web-order-summary {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
        }

        .summary-row.total {
          border-top: 2px solid #e5e5e5;
          border-bottom: 2px solid #e5e5e5;
          padding: 12px 0;
          margin: 10px 0;
          font-weight: bold;
        }

        .order-dates {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 15px;
        }

        .date-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .date-item.overdue {
          color: #dc3545;
          font-weight: bold;
        }

        .order-stats {
          display: flex;
          justify-content: space-around;
          align-items: center;
        }

        .stat-item {
          text-align: center;
        }

        .stat-label {
          font-size: 14px;
          opacity: 0.8;
          margin-bottom: 5px;
          color: #ffffff;
        }

        .stat-value {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
        }

        .products-grid {
          display: grid;
          gap: 20px;
          max-height: calc(140vh - 200px);
          overflow-y: auto;
          padding-right: 10px;
        }

        .web-product-card {
          border-radius: 12px;
          border: 1px solid #e5e5e5;
        }

        .product-content {
          display: flex;
          gap: 15px;
          padding: 20px;
        }

        .product-image-section {
          flex-shrink: 0;
        }

        .product-image {
          width: 120px;
          height: 120px;
          object-fit: cover;
          border-radius: 8px;
          cursor: pointer;
          border: 1px solid #f0f0f0;
        }

        .product-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .product-title {
          font-size: 16px;
          font-weight: bold;
          margin: 0;
          color: #000000;
        }

        .product-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
        }

        .info-label {
          opacity: 0.7;
          font-size: 12px;
          color: #666666;
        }

        .info-value {
          font-size: 12px;
          color: #000000;
        }

        .product-pricing {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 5px;
        }

        .original-price {
          text-decoration: line-through;
          opacity: 0.6;
          font-size: 14px;
          color: #999999;
        }

        .current-price {
          font-size: 16px;
          font-weight: bold;
          color: #10b981;
        }

        .product-quantity-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .quantity-stepper {
          display: flex;
          align-items: center;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
          overflow: hidden;
        }

        .stepper-btn {
          background: #000000;
          border: none;
          color: #ffffff;
          padding: 8px 12px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .stepper-btn:hover {
          background: #333333;
        }

        .quantity-input {
          width: 50px;
          text-align: center;
          border: none;
          background: #ffffff;
          color: #000000;
          padding: 8px;
          border-left: 1px solid #e5e5e5;
          border-right: 1px solid #e5e5e5;
        }

        .quantity-display {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .quantity-label {
          opacity: 0.7;
          color: #666666;
        }

        .quantity-value {
          font-weight: bold;
          color: #000000;
        }

        .total-price {
          font-weight: bold;
          color: #10b981;
        }

        .products-grid::-webkit-scrollbar {
          width: 6px;
        }

        .products-grid::-webkit-scrollbar-track {
          background: #f0f0f0;
          border-radius: 3px;
        }

        .products-grid::-webkit-scrollbar-thumb {
          background: #6f42c1;
          border-radius: 3px;
        }

        /* Loading Images Styles */
        .loading-images-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        .loading-images-grid-mobile {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }

        .loading-image-container {
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
        }

        .loading-image-container-mobile {
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
        }

        .loading-image {
          width: 100%;
          height: 200px;
          object-fit: cover;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .loading-image:hover {
          transform: scale(1.05);
        }

        .loading-image-mobile {
          width: 100%;
          height: 150px;
          object-fit: cover;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .loading-image-mobile:active {
          transform: scale(1.05);
        }

        /* Download Buttons Styles */
        .download-buttons-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        .download-buttons-mobile {
          display: flex;
          justify-content: space-between;
          gap: 10px;
        }

        .download-btn:hover {
          opacity: 0.9;
          transform: translateY(-2px);
          transition: all 0.3s ease;
        }

        .download-btn-mobile:active {
          opacity: 0.9;
          transform: translateY(-1px);
          transition: all 0.2s ease;
        }

        @media (max-width: 768px) {
          .mt-2 {
            margin-top: 73px !important;
          }
          .web-grid-layout {
            grid-template-columns: 1fr;
            gap: 20px;
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default MyOrderds;
